import { LucideIcon } from "lucide-react";
import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";
import { alertVariants } from "./alert-variants.constant";

interface AlertProps {
  variant?: keyof typeof alertVariants;
  containerClassName?: string;
  Icon?: LucideIcon;
  iconClassName?: string;
}

const Alert = ({ variant, containerClassName, Icon, iconClassName, children }: PropsWithChildren<AlertProps>) => {
  return (
    <div
      className={twMerge(
        'flex items-center gap-3 p-4 rounded-lg',
        alertVariants[variant || 'default'].containerClassName,
        containerClassName
      )}
    >
      {Icon && (
        <Icon
          strokeWidth={1.5}
          className={twMerge('size-5', alertVariants[variant || 'default'].textClassName, iconClassName)}
        />
      )}

      {children}
    </div>
  )
}

export default Alert;
